import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-03/task-03";

const task: Slide = {
  descriptionHtml:
    "A damped mechanical oscillator with the following parameters  M<sub>m</sub>=1 g, C<sub>m</sub>=3.9 mm/N and R<sub>m</sub> = 0.5 kg/s is excited with a 2 N force at 80 Hz. Give the amplitude of the velocity in m/s.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
